import { router, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types'

// Persistent warning shown while a system admin is impersonating this user.
// Rendered in the consumer layouts (AccountLayout / SurveyLayout).
export default function ImpersonationBanner() {
  const { impersonation, current_user } = usePage<{ props: SharedProps }>().props as unknown as SharedProps
  if (!impersonation?.active) return null

  return (
    <div role="alert" className="alert alert-warning rounded-none border-x-0 border-t-0">
      <span className="iconify lucide--venetian-mask size-5" />
      <div className="flex-1 text-sm">
        <strong>Impersonating {current_user?.email_address}</strong>
        {impersonation.admin_email_address && (
          <span className="ms-2 opacity-80">(you are {impersonation.admin_email_address})</span>
        )}
      </div>
      <button
        type="button"
        className="btn btn-sm"
        onClick={() => router.delete('/system_admin/impersonation')}
      >
        <span className="iconify lucide--undo-2 size-4" />
        Revert
      </button>
    </div>
  )
}
